var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cf0e483826454387d8a846bd0d6348a6d147c5d4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["blipp-frontend@blipp-ab"]={id:"cf0e483826454387d8a846bd0d6348a6d147c5d4"};
      